import PropTypes from 'prop-types';
import React, { Component } from 'react';

import SettingsPage from '@/components/SettingsPage';
import SettingsPageContent from '@/components/SettingsPageContent';
import SettingsPageHeader from '@/components/SettingsPageHeader';
import SettingsPageTitle from '@/components/SettingsPageTitle';

import Table from './Table';

class Beacons extends Component {
  static propTypes = {
    error: PropTypes.any,
    isLoading: PropTypes.bool.isRequired,
    itemsIds: PropTypes.arrayOf(PropTypes.any).isRequired,
    totalCount: PropTypes.number.isRequired,
  };

  static defaultProps = {
    error: null,
  };

  render() {
    const { error, isLoading, itemsIds, totalCount } = this.props;

    return (
      <SettingsPage>
        <SettingsPageHeader borderBottom gutterBottom={false}>
          <SettingsPageTitle>Маяки</SettingsPageTitle>
        </SettingsPageHeader>
        <SettingsPageContent>
          <Table
            error={error}
            isLoading={isLoading}
            items={itemsIds}
            totalCount={totalCount}
          />
        </SettingsPageContent>
      </SettingsPage>
    );
  }
}

export default Beacons;
